// @vendor
const React = require('react');
const { withRouter } = require('react-router-dom');
const PropTypes = require('prop-types');

// @ utilities
const usd = require('utilities/usd');

// @constants
const DEFAULT_URL = '/myprofile/global';

class NavigateToPathView extends React.Component {
    componentDidMount() {
        const url = usd.getNavigateURL();
        this.props.history.push(url || DEFAULT_URL);
    }

    render() {
        return (<noscript/>);
    }
}

NavigateToPathView.propTypes = {
    history: PropTypes.object.isRequired,
}

module.exports.NavigateToPathView = withRouter(NavigateToPathView);
